module.exports = __webpack_public_path__ + "img/default_img.4911232f.png";